import { createContext, useContext } from "react";
const FormContext = createContext(void 0);
function useForm() {
  const context = useContext(FormContext);
  if (context === void 0) {
    throw new Error("useForm must be used within a FormProvider");
  }
  return context;
}
function useNestedFormByTarget(target) {
  const form = useForm();
  if (!form.nestedForms?.length) {
    return;
  }
  return form.nestedForms?.find(
    (nestedForm) => nestedForm.targets?.includes(target)
  )?.form;
}
export {
  FormContext,
  useForm,
  useNestedFormByTarget
};
//# sourceMappingURL=form-context.js.map
